import gql from 'graphql-tag'
import ManufacturersPage from './manufacturersPage'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RigipsStore } from 'redux/redux'
import { withTranslation } from 'react-i18next'

export type CompanyInfo = {
  id: string
  name: string
  name_short: string
  logo: string
}

export const MANUFACTURERS_QUERY = gql`
  query getManufacturers {
    getCompanies {
      id
      name
      name_short
      logo
    }
  }
`

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state
  const { authenticated } = auth

  return { authenticated }
}

const withConnect = connect(mapStateToProps)

export default withConnect(withRouter(withTranslation()(ManufacturersPage)))
